import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '@taxdown/piccolo-web';
import { history } from 'Store';
import { searchSelector } from 'Store/modules/router/selectors';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';
import { signOutAction } from 'Store/modules/auth/actions';
import { routes } from 'Constants/routes';

const PartnerSignIn = (): JSX.Element => {
  const dispatch = useDispatch();
  const search = useSelector(searchSelector);
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(signOutAction());
    } else {
      history.push({
        pathname: routes.SIGNIN,
        search,
      });
    }
  }, []);
  return <Spinner size="M" justify="center" align="center" />;
};

export default PartnerSignIn;
